/* eslint-disable radix */
import {} from "react";
import i18n from "../language/i18n";

export const formatCurrency = (value?: string | number, currencyCode?: string) => {
  let code = "VND";
  if (currencyCode && currencyCode !== "") {
    code = currencyCode;
  }
  let money: number = 0;
  if (!value) {
    value = "0";
  }
  const { format } = new Intl.NumberFormat("en-US", { style: "currency", currency: "VND", maximumFractionDigits: 6 });
  money = Number(String(value).replace(/,/g, ""));
  const codeName = code === "VND" ? i18n.t("COMMON_VND") : code;
  const result = format(money).replace("₫", "") + " " + codeName.toUpperCase();
  return result;
};

export const formatNumberThousand = (value?: string | number | null) => {
  let money: number = 0;
  if (!value) {
    value = "0";
  }
  const { format } = new Intl.NumberFormat("en-US", { style: "currency", currency: "VND", maximumFractionDigits: 6 });
  money = Number(String(value).replace(/,/g, ""));
  return format(money).replace("₫", "");
};

interface settingMask {
  precision: number;
  separator: string;
  delimiter: string;
  unit: string;
  suffixUnit?: string;
  zeroCents?: string;
  lastOutput?: string;
  moneyPrecision: number;
}

export class FormatMaskedTextInput {
  createOption(options?: settingMask) {
    let optionsConfig: settingMask = {
      precision: 0,
      separator: ".",
      delimiter: ",",
      unit: "",
      moneyPrecision: 0,
    };
    if (options) optionsConfig = options;
    return optionsConfig;
  }

  insertString(text: string, index: number, str: string) {
    if (index > 0) {
      return text.substring(0, index) + str + text.substring(index, text.length);
    } else {
      return str + text;
    }
  }

  sanitize(text: string, settings: any) {
    if (typeof text === "number") {
      return Number(text).toFixed(settings.precision);
    }
    return text;
  }

  removeNotNumbers(text: string) {
    return text.replace(/[^0-9]+/g, "");
  }

  getValue(value: string, isShowZero?: boolean) {
    const optionsConfig = this.createOption();
    let sanitized = this.sanitize(value, optionsConfig);
    let masked = this.toMoney(sanitized, optionsConfig, isShowZero);
    return masked;
  }

  getRawValue(maskedValue: string) {
    const optionsConfig = this.createOption();
    let normalized = this.removeNotNumbers(maskedValue);
    let dotPosition = normalized.length - optionsConfig.precision;
    normalized = this.insertString(normalized, dotPosition, ".");
    return Number(normalized);
  }

  mergeMoneyOptions(opts: settingMask) {
    opts = opts || {};
    opts = {
      precision: opts.hasOwnProperty("precision") ? opts.precision : 2,
      separator: opts.separator || ",",
      delimiter: opts.delimiter || ".",
      unit: opts.unit ? opts.unit + " " : "",
      suffixUnit: (opts.suffixUnit && " " + opts.suffixUnit.replace(/[\s]/g, "")) || "",
      zeroCents: opts.zeroCents,
      lastOutput: opts.lastOutput,
      moneyPrecision: 0,
    };
    opts.moneyPrecision = opts.zeroCents ? 0 : opts.precision;
    return opts;
  }

  toMoney = (value: string, opts: settingMask, isShowZero?: boolean) => {
    opts = this.mergeMoneyOptions(opts);
    if (opts.zeroCents) {
      opts.lastOutput = opts.lastOutput || "";
      var zeroMatcher = "(" + opts.separator + "[0]{0," + opts.precision + "})",
        zeroRegExp = new RegExp(zeroMatcher, "g"),
        digitsLength = value.toString().replace(/[\D]/g, "").length || 0,
        lastDigitLength = opts.lastOutput.toString().replace(/[\D]/g, "").length || 0;
      value = value.toString().replace(zeroRegExp, "");
      if (digitsLength < lastDigitLength) {
        value = value.slice(0, value.length - 1);
      }
    }
    var number = value.toString().replace(/[\D]/g, ""),
      clearDelimiter = new RegExp("^(0|\\" + opts.delimiter + ")"),
      clearSeparator = new RegExp("(\\" + opts.separator + ")$"),
      money = number.substr(0, number.length - opts.moneyPrecision),
      masked = money.substr(0, money.length % 3),
      cents = new Array(opts.precision + 1).join("0");
    money = money.substr(money.length % 3, money.length);
    for (var i = 0, len = money.length; i < len; i++) {
      if (i % 3 === 0) {
        masked += opts.delimiter;
      }
      masked += money[i];
    }
    masked = masked.replace(clearDelimiter, "");
    masked = masked.length ? masked : isShowZero && value === "0" ? "0" : "";
    if (!opts.zeroCents) {
      var beginCents = number.length - opts.precision,
        centsValue = number.substr(beginCents, opts.precision),
        centsLength = centsValue.length,
        centsSliced = opts.precision > centsLength ? opts.precision : centsLength;
      cents = (cents + centsValue).slice(-centsSliced);
    }

    var unitToApply = opts.unit[opts.unit.length - 1] === " " ? opts.unit.substring(0, opts.unit.length - 1) : opts.unit;
    var output = unitToApply + masked + opts.separator + cents + opts.suffixUnit;
    return output.replace(clearSeparator, "");
  };
}

const TxtNumber: Array<string> = [" không", " một", " hai", " ba", " bốn", " năm", " sáu", " bảy", " tám", " chín"];
const TxtUnit: Array<string> = ["", " nghìn", " triệu", " tỷ", " nghìn tỷ", " triệu tỷ"];

export class ConvertCurrencyToVietnamese {
  getNumBerThousand(value: number, isTxt?: boolean): string {
    let tram: number = 0;
    let chuc: number = 0;
    let donvi: number = 0;
    let KetQua: string = "";
    tram = parseInt((value / 100).toString());
    chuc = parseInt(((value % 100) / 10).toString());
    donvi = parseInt((value % 10).toString());
    if (tram === 0 && chuc === 0 && donvi === 0) return "";
    if (tram !== 0) {
      KetQua += TxtNumber[tram] + " trăm";
      if (chuc === 0 && donvi !== 0) KetQua += " linh";
    }
    if (isTxt && tram === 0) KetQua += " không trăm";
    if (chuc !== 0 && chuc !== 1) {
      KetQua += TxtNumber[chuc] + " mươi";
      if (chuc === 0 && donvi !== 0) KetQua = KetQua + " linh";
    }
    if (chuc === 1) KetQua += " mười";

    switch (donvi) {
      case 1:
        if (chuc !== 0 && chuc !== 1) {
          KetQua += " mốt";
        } else {
          if (isTxt && tram === 0 && chuc === 0) KetQua += " lẻ" + TxtNumber[donvi];
          else KetQua += TxtNumber[donvi];
        }
        break;
      case 5:
        if (chuc === 0) {
          if (isTxt && tram === 0 && chuc === 0) KetQua += " lẻ" + TxtNumber[donvi];
          else KetQua += TxtNumber[donvi];
        } else {
          KetQua += " lăm";
        }
        break;
      default:
        if (donvi !== 0) {
          if (isTxt && tram === 0 && chuc === 0) KetQua += " lẻ" + TxtNumber[donvi];
          else KetQua += TxtNumber[donvi];
        }
        break;
    }
    return KetQua;
  }

  convert(value: number) {
    let lan = 0;
    let i = 0;
    let so: number = 0;
    let KetQua = "";
    let tmp = "";
    let ViTri: Array<string | number> = [];

    if (value < 0) return "Số tiền âm !";
    if (value === 0) return "Không đồng !";
    if (value > 0) {
      so = value;
    } else {
      so = -value;
    }
    if (value > 9999999999999999) {
      return "Số quá lớn!";
    }
    ViTri[5] = Math.floor(so / 1000000000000000);
    if (isNaN(ViTri[5])) ViTri[5] = "0";
    so = so - parseFloat(ViTri[5].toString()) * 1000000000000000;
    ViTri[4] = Math.floor(so / 1000000000000);
    if (isNaN(ViTri[4])) ViTri[4] = "0";
    so = so - parseFloat(ViTri[4].toString()) * 1000000000000;
    ViTri[3] = Math.floor(so / 1000000000);
    if (isNaN(ViTri[3])) ViTri[3] = "0";
    so = so - parseFloat(ViTri[3].toString()) * 1000000000;
    ViTri[2] = parseInt((so / 1000000).toString());
    if (isNaN(ViTri[2])) ViTri[2] = "0";
    ViTri[1] = parseInt(((so % 1000000) / 1000).toString());
    if (isNaN(ViTri[1])) ViTri[1] = "0";
    ViTri[0] = parseInt((so % 1000).toString());
    if (isNaN(ViTri[0])) ViTri[0] = "0";
    if (ViTri[5] > 0) {
      lan = 5;
    } else if (ViTri[4] > 0) {
      lan = 4;
    } else if (ViTri[3] > 0) {
      lan = 3;
    } else if (ViTri[2] > 0) {
      lan = 2;
    } else if (ViTri[1] > 0) {
      lan = 1;
    } else {
      lan = 0;
    }

    for (i = lan; i >= 0; i--) {
      const thousand = Number(ViTri[i]);
      tmp = this.getNumBerThousand(thousand, i !== lan);
      KetQua += tmp;
      if (ViTri[i] > 0) {
        if (i !== lan && tmp !== "" && (i === 4 || i === 5)) {
          KetQua += TxtUnit[i].replace(" tỷ", "");
        } else KetQua += TxtUnit[i];
      }
      if (i > 0 && tmp.length > 0) KetQua += ","; //&& (!string.IsNullOrEmpty(tmp))
    }
    if (KetQua.substring(KetQua.length - 1) === ",") {
      KetQua = KetQua.substring(0, KetQua.length - 1);
    }
    KetQua = KetQua.substring(1, 2).toUpperCase() + KetQua.substring(2) + " đồng";
    return KetQua; //.substring(0, 1);//.toUpperCase();// + KetQua.substring(1);
  }
}

const th = ["", "thousand", "million", "billion", "trillion"];
const dg = ["zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine"];
const tn = ["ten", "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen", "seventeen", "eighteen", "nineteen"];
const tw = ["twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety"];

export const NumInWords = (amount: number) => {
  let s = amount.toString();
  s = s.replace(/[\, ]/g, "");
  if (amount !== parseFloat(s)) return "not a number";
  let x = s.indexOf(".");
  if (x === -1) x = s.length;
  if (x > 15) return "too big";
  let n = s.split("");
  let str = "";
  let sk = 0;
  for (let i = 0; i < x; i++) {
    if ((x - i) % 3 === 2) {
      if (n[i] === "1") {
        str += tn[Number(n[i + 1])] + " ";
        i++;
        sk = 1;
      } else if (Number(n[i]) !== 0) {
        str += tw[Number(n[i]) - 2] + " ";
        sk = 1;
      }
    } else if (Number(n[i]) !== 0) {
      str += dg[Number(n[i])] + " ";
      if ((x - i) % 3 === 0) str += "hundred ";
      sk = 1;
    }
    if ((x - i) % 3 === 1) {
      if (sk) str += th[(x - i - 1) / 3] + " ";
      sk = 0;
    }
  }

  if (x !== s.length) {
    let y = s.length;
    str += "point ";
    for (let i = x + 1; i < y; i++) str += dg[Number(n[i])] + " ";
  }
  return str.replace(/\s+/g, " ");
};
